import { paperStyles } from '@festina-life/ui/libs'
import { Typography } from '@festina-life/ui/structure'
import cx from 'classnames'
import type { PropsWithChildren } from 'react'

type Props = PropsWithChildren<{
  title: React.ReactNode
  isFaded?: boolean
}>

export const ManageHeader = ({ title, children, isFaded = false }: Props) => (
  <div
    className={cx(
      'w-full flex gap-x-2 mb-2',
      paperStyles({ borders: ['bottom'], isFaded }),
    )}
  >
    <Typography
      size="sm"
      className={cx('mb-1 w-full', { uppercase: typeof title === 'string' })}
    >
      {title}
    </Typography>
    {children}
  </div>
)
